
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/we-have-a-blog",
      function () {
        return require("private-next-pages/blog/we-have-a-blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/we-have-a-blog"])
      });
    }
  